document.addEventListener('DOMContentLoaded', () => {

    let modal = document.querySelector('#added-notification');
    let closeBtn = modal.querySelector('.js-close-notification');
    closeBtn.addEventListener('click', function() {
        modal.classList.remove('shown');
    });

    let cartPage = document.querySelector('#cart-items');
    if (cartPage) {
        console.log('Cart page found');
        let originalFetch = window.fetch;
        window.fetch = async function(...args) {
            let response = await originalFetch(...args);
            if (args[0].includes('/change')) {
                console.log('Change event detected');
                let event = new CustomEvent('customCartChange', { detail: { url: args[0], options: args[1] } });
                document.dispatchEvent(event);
            }
            return response;
        };
    }

    // Custom book trial functionality on product pages
    let bookTrialButton = document.querySelector('#book-trial');
    if (bookTrialButton) {
        let bookModal = document.querySelector('.book-trial-modal');
        let bookModalContent = bookModal.querySelector('.book-trial-modal__content');
        let closeBookModal = bookModal.querySelector('.close-modal');
        bookTrialButton.addEventListener('click', function() {
            bookModal.style.display = 'flex';
            setTimeout(() => {
                bookModalContent.classList.add('shown');
            },300);
        });
        closeBookModal.addEventListener('click', function() {
            bookModalContent.classList.remove('shown');
            setTimeout(() => {
                bookModal.style.display = 'none';
            }, 300);
        });
        // Close modal if clicking outside the modal content
            bookModal.addEventListener('click', function handler(e) {
                if (!bookModalContent.contains(e.target)) {
                    bookModalContent.classList.remove('shown');
                    setTimeout(() => {
                        bookModal.style.display = 'none';
                    }, 300);
                    bookModal.removeEventListener('click', handler);
                }
            });
    }
    let bookButton = document.querySelector('.custom-open-formula');
    if (bookButton) {
        let bookModal = document.querySelector('.book-trial-modal');
        let bookModalContent = bookModal.querySelector('.book-trial-modal__content');
        let closeBookModal = bookModal.querySelector('.close-modal');
        bookButton.addEventListener('click', function() {
            bookModal.style.display = 'flex';
            setTimeout(() => {
                bookModalContent.classList.add('shown');
            },300);
        });
        closeBookModal.addEventListener('click', function() {
            bookModalContent.classList.remove('shown');
            setTimeout(() => {
                bookModal.style.display = 'none';
            }, 300);
        });
        // Close modal if clicking outside the modal content
            bookModal.addEventListener('click', function handler(e) {
                if (!bookModalContent.contains(e.target)) {
                    bookModalContent.classList.remove('shown');
                    setTimeout(() => {
                        bookModal.style.display = 'none';
                    }, 300);
                    bookModal.removeEventListener('click', handler);
                }
            });
    }

    let serviceButton = document.querySelector('.modal-open-service');
    if (serviceButton) {
        let serviceModal = document.querySelector('.cart-page-service-modal');
        let serviceModalContent = serviceModal.querySelector('.cart-page-service-modal__content');
        let closeServiceModal = serviceModal.querySelector('.close-modal');
        let submit = serviceModal.querySelector('.button-container button');
        serviceButton.addEventListener('click', function() {
            serviceModal.style.display = 'flex';
            setTimeout(() => {
                serviceModalContent.classList.add('shown');
            },300);
        });
        closeServiceModal.addEventListener('click', function() {
            serviceModalContent.classList.remove('shown');
            setTimeout(() => {
                serviceModal.style.display = 'none';
            }, 300);
        });
        submit.addEventListener('click', function() {
            serviceModalContent.classList.remove('shown');
            setTimeout(() => {
                serviceModal.style.display = 'none';
            }, 300);
        });
        // Close modal if clicking outside the modal content
            serviceModal.addEventListener('click', function handler(e) {
                if (!serviceModalContent.contains(e.target)) {
                    serviceModalContent.classList.remove('shown');
                    setTimeout(() => {
                        serviceModal.style.display = 'none';
                    }, 300);
                    serviceModal.removeEventListener('click', handler);
                }
            });
    }
    
});

document.addEventListener('customCartChange', (e) => console.log('Custom Event Triggered:', e));